import React from "react";
import { Header } from "./presentational/header";
import { Footer } from "./presentational/footer";
import { CardCodeInput } from "./panels/cardCodeInput";
import { CampaignWelcome } from "./panels/campaignWelcome";
import { CampaignThankYou } from "./panels/campaignThankYou";
import { CampaignInstructions } from "./panels/campaignInstructions";
import { CategorySelector } from "./panels/categorySelector";
import { FeaturedCharitySelector } from "./panels/featuredCharitySelector";
import { NationalCharitySelector } from "./panels/nationalCharitySelector";
import { CharityDetails } from "./panels/charityDetails";
import { CharityDistribution } from "./panels/charityDistribution";
import { ThankYou } from "./panels/thankYou";
import { ShareSpend } from "./panels/shareSpend";
import { CodeError } from "./panels/codeError";
// import ReactGA from "react-ga";
import * as consts from "../consts";
import * as utilities from "../middleware/utilities";
import styles from "../styles/app.css";
import { Route, Switch, withRouter } from "react-router-dom";

//const styles = {
//   app: {
//     fontFamily: "'Century Gothic', CenturyGothic, AppleGothic, sans-serif",
//   },
//   content: {
//     marginTop: "66px",
//     minHeight: "90vh",
//   },
// };

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      busy: true,
      account: null,
      originUrl: "/",
      code: "",
      email: "",
      notifyEmail: "",
      name: "",
      thankYouName: "",
      thankYouNote: "",
      instructions: {
        distributionType: "No Instructions",
        name: "",
        phone: "",
        email: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        notes: "",
      },
      optIn: false,
      donation: null,
      validation: {
        code: true,
        email: true,
        name: true,
        notifyEmail: true,
        total: true,
        inBounds: true,
        thankYouName: true,
        thankYouNote: true,
      },
      categories: [],
      selectedCharities: [],
      tempCharity: null,
      dateSpent: null,
      collapseSelectedCharities: false,
    };
  }

  componentDidMount() {
    utilities.getAccount().then((account) => {
      if (account && account.enabled) {
        let urlSearchParams = new URLSearchParams(window.location.search);
        let code = urlSearchParams.get("code");
        if (!code) {
          code = urlSearchParams.get("Code");
        }
        if (code) {
          code = code.toUpperCase();
        }
        let email = urlSearchParams.get("email");
        if (!email) {
          email = urlSearchParams.get("Email");
        }
        let validCode = utilities.validateCode(code);
        let validEmail = utilities.validateEmail(email);
        this.setState({
          account: account,
          busy: false,
          code: validCode ? code : "",
          email: validEmail ? email : "",
          notifyEmail: validEmail ? email : "",
          thankYouNote:
            account.settings.dictionary.thank_you_input_thank_you_note_value,
        });
      } else {
        if (process.env.NODE_ENV === "development") {
          console.log("TisBest Spend: Invalid Account");
        }
      }
    });
  }
  resetScroll() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  setInitialDistribution(props) {
    if (this.state.selectedCharities.length > 0) {
      let selectedCharities = this.state.selectedCharities.slice();
      let dollars = Math.trunc(this.state.donation.amount);
      let cents =
        Math.round((this.state.donation.amount - dollars) * 100) / 100;
      let amount = Math.floor(dollars / selectedCharities.length);
      let remainder = dollars % selectedCharities.length;
      selectedCharities.map((charity, index) => {
        charity.amount = amount + (index == 0 ? remainder : 0);
        charity.cents = index == 0 ? cents : 0;
      });
      this.setState(
        {
          selectedCharities: selectedCharities,
          thankYouName: "",
          thankYouNote:
            this.state.account.settings.dictionary
              .thank_you_input_thank_you_note_value,
          instructions: {
            distributionType: "No Instructions",
            name: "",
            phone: "",
            email: "",
            address: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            notes: "",
          },
          validation: {
            ...this.state.validation,
            total: true,
            inBounds: true,
          },
        },
        () => {
          this.resetScroll();
          props.history.push(
            this.state.originUrl + consts.PANEL_CHARITY_DISTRIBUTION
          );
        }
      );
    }
  }
  openSearch(props) {
    this.resetScroll();
    props.history.push(
      this.state.originUrl + consts.PANEL_NATIONAL_CHARITY_SELECTOR
    );
  }
  goBack(props) {
    this.resetScroll();
    props.history.goBack();
  }
  openCodeError(props) {
    this.resetScroll();
    if (this.state.code) {
      props.history.push(this.state.originUrl + consts.PANEL_CODE_ERROR);
    } else {
      props.history.push(this.state.originUrl + consts.PANEL_CARD_CODE_INPUT);
    }
  }
  reset(props) {
    this.resetScroll();
    this.setState(
      {
        code: "",
        email: "",
        notifyEmail: "",
        name: "",
        thankYouName: "",
        thankYouNote: "",
        instructions: {
          distributionType: "No Instructions",
          name: "",
          phone: "",
          email: "",
          address: "",
          address2: "",
          city: "",
          state: "",
          zip: "",
          notes: "",
        },
        optIn: false,
        donation: null,
        validation: {
          code: true,
          email: true,
          name: true,
          notifyEmail: true,
          total: true,
          inBounds: true,
          thankYouName: true,
          thankYouNote: true,
        },
        categories: [],
        selectedCharities: [],
        dateSpent: null,
        collapseSelectedCharities: false,
      },
      () => {
        props.history.push(this.state.originUrl);
      }
    );
  }
  removeCharity(ein) {
    // ReactGA.event({
    //   category: "User Action",
    //   action: "Remove Charity",
    //   label: ein,
    // });
    let selectedCharities = this.state.selectedCharities.filter((charity) => {
      return charity.ein != ein;
    });
    this.setState({ selectedCharities: selectedCharities });
  }
  selectCharity(charity) {
    // ReactGA.event({
    //   category: "User Action",
    //   action: "Select Charity",
    //   label: charity.ein,
    // });
    let selectedIndex = this.state.selectedCharities.findIndex((item) => {
      return item.ein == charity.ein;
    });
    if (
      selectedIndex == -1 &&
      this.state.account.settings.additionalCharityCount >=
        this.state.selectedCharities.length
    ) {
      let selectedCharities = this.state.selectedCharities.slice();
      selectedCharities.push({ ...charity });
      this.setState({
        selectedCharities: selectedCharities,
        collapseSelectedCharities: false,
      });
    }
  }
  viewCharity(charity, props) {
    this.setState({ tempCharity: charity }, () => {
      // ReactGA.event({
      //   category: "User Action",
      //   action: "View Charity",
      //   label: charity.ein,
      // });
      this.resetScroll();
      props.history.push(
        this.state.originUrl +
          consts.PANEL_CHARITY_DETAILS +
          "/" +
          (props.match.params.categoryID ? props.match.params.categoryID : 0) +
          "/" +
          charity.ein
      );
    });
  }
  selectCategory(category, props) {
    // ReactGA.event({
    //   category: "User Action",
    //   action: "Select Category",
    //   label: category.title,
    // });
    this.setState(
      {
        busy: false,
      },
      () => {
        this.resetScroll();
        props.history.push(
          this.state.originUrl +
            consts.PANEL_FEATURED_CHARITY_SELECTOR +
            "/" +
            category.id
        );
      }
    );
  }
  renderPanel() {
    return (
      <Switch>
        <Route
          path={this.state.originUrl + consts.PANEL_CAMPAIGN_WELCOME}
          render={(props) => (
            <CampaignWelcome
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              images={this.state.account.settings.images}
              donation={this.state.donation}
              selectedCharities={this.state.selectedCharities}
              code={this.state.code}
              onCodeError={() => {
                this.openCodeError(props);
              }}
              additionalCharityCount={
                this.state.account.settings.additionalCharityCount
              }
              onViewCharity={(charity) => {
                this.viewCharity(charity, props);
              }}
              onSelectCharity={(charity) => {
                this.selectCharity(charity);
              }}
              onRemoveCharity={(ein) => {
                this.removeCharity(ein);
              }}
              onContinue={() => {
                this.setState(
                  {
                    busy: false,
                  },
                  () => {
                    this.resetScroll();
                    props.history.push(
                      this.state.originUrl + consts.PANEL_CATEGORY_SELECTOR
                    );
                  }
                );
              }}
            />
          )}
        />
        <Route
          path={this.state.originUrl + consts.PANEL_CAMPAIGN_THANK_YOU}
          render={(props) => (
            <CampaignThankYou
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              images={this.state.account.settings.images}
              donation={this.state.donation}
              code={this.state.code}
              onCodeError={() => {
                this.reset(props);
                //this.openCodeError(props);
              }}
              onContinue={() => {
                this.resetScroll();
                props.history.push(
                  this.state.originUrl + consts.PANEL_THANK_YOU
                );
              }}
              onBack={() => {
                this.goBack(props);
              }}
            />
          )}
        />
        <Route
          path={this.state.originUrl + consts.PANEL_CAMPAIGN_INSTRUCTIONS}
          render={(props) => (
            <CampaignInstructions
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              instructions={this.state.instructions}
              validation={this.state.account.settings.validation}
              images={this.state.account.settings.images}
              donation={this.state.donation}
              selectedCharities={this.state.selectedCharities}
              code={this.state.code}
              onInstructionsChanged={(instructions) => {
                this.setState({ instructions: instructions });
              }}
              onCodeError={() => {
                this.reset(props);
                //this.openCodeError(props);
              }}
              onContinue={() => {
                this.resetScroll();
                props.history.push(
                  this.state.originUrl +
                    (this.state.donation.campaignDetail &&
                    this.state.donation.campaignDetail.thankYouMarkup
                      ? consts.PANEL_CAMPAIGN_THANK_YOU
                      : consts.PANEL_THANK_YOU)
                );
              }}
              onBack={() => {
                this.goBack(props);
              }}
            />
          )}
        />
        <Route
          path={this.state.originUrl + consts.PANEL_CATEGORY_SELECTOR}
          render={(props) => (
            <NationalCharitySelector
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              additionalCharityCount={
                this.state.account.settings.additionalCharityCount
              }
              validation={this.state.account.settings.validation}
              images={this.state.account.settings.images}
              donation={this.state.donation}
              categories={this.state.categories}
              selectedCharities={this.state.selectedCharities}
              collapseSelectedCharities={this.state.collapseSelectedCharities}
              code={this.state.code}
              onCodeError={() => {
                this.openCodeError(props);
              }}
              onToggleCollapseSelectedCharities={() => {
                this.setState({
                  collapseSelectedCharities:
                    !this.state.collapseSelectedCharities,
                });
              }}
              onSelectCategory={(category) => {
                this.selectCategory(category, props);
              }}
              onSelectCharity={(charity) => {
                this.selectCharity(charity);
              }}
              onRemoveCharity={(ein) => {
                this.removeCharity(ein);
              }}
              onViewCharity={(charity) => {
                this.viewCharity(charity, props);
              }}
              onBack={() => {
                this.goBack(props);
              }}
              onContinue={() => {
                this.setInitialDistribution(props);
              }}
              onSearchAll={() => {
                this.openSearch(props);
              }}
            />
          )}
        />
        <Route
          path={
            this.state.originUrl + consts.PANEL_FEATURED_CHARITY_SELECTOR + "/0"
          }
          render={(props) => (
            <CategorySelector
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              additionalCharityCount={
                this.state.account.settings.additionalCharityCount
              }
              validation={this.state.account.settings.validation}
              images={this.state.account.settings.images}
              donation={this.state.donation}
              categories={this.state.categories}
              selectedCharities={this.state.selectedCharities}
              collapseSelectedCharities={this.state.collapseSelectedCharities}
              code={this.state.code}
              onCodeError={() => {
                this.openCodeError(props);
              }}
              onToggleCollapseSelectedCharities={() => {
                this.setState({
                  collapseSelectedCharities:
                    !this.state.collapseSelectedCharities,
                });
              }}
              onViewCharity={(charity) => {
                this.viewCharity(charity, props);
              }}
              onSelectCharity={(charity) => {
                this.selectCharity(charity);
              }}
              onRemoveCharity={(ein) => {
                this.removeCharity(ein);
              }}
              onSelectCategory={(category) => {
                this.selectCategory(category, props);
              }}
              onRemoveCharity={(ein) => {
                this.removeCharity(ein);
              }}
              onSearchAll={() => {
                this.openSearch(props);
              }}
              onContinue={() => {
                this.setInitialDistribution(props);
              }}
            />
          )}
        />
        <Route
          path={
            this.state.originUrl +
            consts.PANEL_FEATURED_CHARITY_SELECTOR +
            "/:categoryID"
          }
          render={(props) => (
            <FeaturedCharitySelector
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              additionalCharityCount={
                this.state.account.settings.additionalCharityCount
              }
              validation={this.state.account.settings.validation}
              images={this.state.account.settings.images}
              donation={this.state.donation}
              categories={this.state.categories}
              selectedCategory={this.state.categories.find((category) => {
                return category.id == props.match.params.categoryID;
              })}
              selectedCharities={this.state.selectedCharities}
              collapseSelectedCharities={this.state.collapseSelectedCharities}
              code={this.state.code}
              onCodeError={() => {
                this.openCodeError(props);
              }}
              onToggleCollapseSelectedCharities={() => {
                this.setState({
                  collapseSelectedCharities:
                    !this.state.collapseSelectedCharities,
                });
              }}
              onSelectCategory={(category) => {
                this.selectCategory(category, props);
              }}
              onSelectCharity={(charity) => {
                this.selectCharity(charity);
              }}
              onRemoveCharity={(ein) => {
                this.removeCharity(ein);
              }}
              onViewCharity={(charity) => {
                this.viewCharity(charity, props);
              }}
              onBack={() => {
                this.goBack(props);
              }}
              onContinue={() => {
                this.setInitialDistribution(props);
              }}
              onSearchAll={() => {
                this.openSearch(props);
              }}
            />
          )}
        />
        <Route
          path={this.state.originUrl + consts.PANEL_NATIONAL_CHARITY_SELECTOR}
          render={(props) => (
            <NationalCharitySelector
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              additionalCharityCount={
                this.state.account.settings.additionalCharityCount
              }
              validation={this.state.account.settings.validation}
              images={this.state.account.settings.images}
              donation={this.state.donation}
              categories={this.state.categories}
              selectedCharities={this.state.selectedCharities}
              collapseSelectedCharities={this.state.collapseSelectedCharities}
              code={this.state.code}
              onCodeError={() => {
                this.openCodeError(props);
              }}
              onToggleCollapseSelectedCharities={() => {
                this.setState({
                  collapseSelectedCharities:
                    !this.state.collapseSelectedCharities,
                });
              }}
              onSelectCategory={(category) => {
                this.selectCategory(category, props);
              }}
              onSelectCharity={(charity) => {
                this.selectCharity(charity);
              }}
              onRemoveCharity={(ein) => {
                this.removeCharity(ein);
              }}
              onViewCharity={(charity) => {
                this.viewCharity(charity, props);
              }}
              onBack={() => {
                this.goBack(props);
              }}
              onContinue={() => {
                this.setInitialDistribution(props);
              }}
              onSearchAll={() => {
                this.openSearch(props);
              }}
            />
          )}
        />
        <Route
          path={
            this.state.originUrl +
            consts.PANEL_CHARITY_DETAILS +
            "/:categoryID" +
            "/:charityID"
          }
          render={(props) => (
            <CharityDetails
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              additionalCharityCount={
                this.state.account.settings.additionalCharityCount
              }
              validation={this.state.account.settings.validation}
              images={this.state.account.settings.images}
              donation={this.state.donation}
              categories={this.state.categories}
              selectedCategory={this.state.categories.find((category) => {
                return category.id == props.match.params.categoryID;
              })}
              tempCharity={this.state.tempCharity}
              selectedCharityID={props.match.params.charityID}
              selectedCharities={this.state.selectedCharities}
              collapseSelectedCharities={this.state.collapseSelectedCharities}
              code={this.state.code}
              onCodeError={() => {
                this.openCodeError(props);
              }}
              onToggleCollapseSelectedCharities={() => {
                this.setState({
                  collapseSelectedCharities:
                    !this.state.collapseSelectedCharities,
                });
              }}
              onSelectCharity={(charity) => {
                // ReactGA.event({
                //   category: "User Action",
                //   action: "Select Charity",
                //   label: charity.ein,
                // });
                let selectedIndex = this.state.selectedCharities.findIndex(
                  (item) => {
                    return item.ein == charity.ein;
                  }
                );
                if (
                  selectedIndex == -1 &&
                  this.state.account.settings.additionalCharityCount >=
                    this.state.selectedCharities.length
                ) {
                  let selectedCharities = this.state.selectedCharities.slice();
                  selectedCharities.push({ ...charity });
                  this.setState(
                    {
                      selectedCharities: selectedCharities,
                    },
                    () => {
                      this.resetScroll();
                      props.history.goBack();
                    }
                  );
                }
              }}
              onRemoveCharity={(ein) => {
                this.removeCharity(ein);
              }}
              onBack={() => {
                this.goBack(props);
              }}
              onContinue={() => {
                this.setInitialDistribution(props);
              }}
              onSearchAll={() => {
                this.openSearch(props);
              }}
            />
          )}
        />
        <Route
          path={this.state.originUrl + consts.PANEL_CHARITY_DISTRIBUTION}
          render={(props) => (
            <CharityDistribution
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              additionalCharityCount={
                this.state.account.settings.additionalCharityCount
              }
              validation={this.state.account.settings.validation}
              images={this.state.account.settings.images}
              donation={this.state.donation}
              categories={this.state.categories}
              selectedCharities={this.state.selectedCharities}
              name={this.state.name}
              email={this.state.notifyEmail}
              optIn={this.state.optIn}
              nameValid={this.state.validation.name}
              emailValid={this.state.validation.notifyEmail}
              totalValid={this.state.validation.total}
              inBoundsValid={this.state.validation.inBounds}
              code={this.state.code}
              onCodeError={() => {
                this.openCodeError(props);
              }}
              onOptInChanged={(optIn) => {
                // ReactGA.event({
                //   category: "User Action",
                //   action: "Opt In",
                // });
                this.setState({
                  optIn: optIn,
                });
              }}
              onNameChanged={(name) => {
                let validName = utilities.validateName(name);
                this.setState({
                  name: name,
                  optIn: true,
                  validation: {
                    ...this.state.validation,
                    name: this.state.validation.name
                      ? this.state.validation.name
                      : validName,
                  },
                });
              }}
              onEmailChanged={(email) => {
                let validEmail = utilities.validateEmail(email);
                this.setState({
                  notifyEmail: email,
                  validation: {
                    ...this.state.validation,
                    email: this.state.validation.email
                      ? this.state.validation.email
                      : validEmail,
                  },
                });
              }}
              onCharityChanged={(amount, ein) => {
                // ReactGA.event({
                //   category: "User Action",
                //   action: "Change Charity Distribution",
                //   label: "$" + amount,
                // });
                let charities = this.state.selectedCharities.slice();
                let inBounds = true;
                charities.map((item) => {
                  if (ein == item.ein) {
                    item.amount = parseInt(amount);
                  }
                  inBounds = inBounds && parseInt(item.amount) >= 3;
                });
                let total = charities.reduce((a, b) => ({
                  amount: a.amount + b.amount,
                }));
                this.setState({
                  selectedCharities: charities,
                  validation: {
                    ...this.state.validation,
                    total:
                      !Number.isInteger(total.amount) ||
                      total.amount == Math.trunc(this.state.donation.amount),
                    inBounds: inBounds,
                  },
                });
              }}
              onBack={() => {
                this.setState(
                  {
                    thankYouName: "",
                    thankYouNote: "",
                    name: "",
                    notifyEmail: this.state.email,
                    validation: {
                      email: true,
                      name: true,
                      notifyEmail: true,
                      total: true,
                      inBounds: true,
                      thankYouName: true,
                      thankYouNote: true,
                    },
                  },
                  () => {
                    this.resetScroll();
                    props.history.push(
                      this.state.originUrl + consts.PANEL_CATEGORY_SELECTOR
                    );
                  }
                );
              }}
              onReset={() => {
                let selectedCharities = this.state.selectedCharities.slice();
                let dollars = Math.trunc(this.state.donation.amount);
                let cents = this.state.donation.amount - dollars;
                let amount = Math.floor(dollars / selectedCharities.length);
                let remainder = dollars % selectedCharities.length;
                selectedCharities.map((charity, index) => {
                  charity.amount = amount + (index == 0 ? remainder : 0);
                  charity.cents = index == 0 ? cents : 0;
                });
                this.setState({
                  selectedCharities: selectedCharities,
                  validation: {
                    ...this.state.validation,
                    total: true,
                    inBounds: true,
                  },
                });
              }}
              onContinue={() => {
                let validName = utilities.validateName(this.state.name);
                let validEmail = utilities.validateEmail(
                  this.state.notifyEmail
                );
                if (
                  this.state.validation.total &&
                  this.state.validation.inBounds &&
                  (!this.state.optIn || (validName && validEmail))
                ) {
                  this.setState(
                    {
                      busy: false,
                    },
                    () => {
                      this.resetScroll();
                      props.history.push(
                        this.state.originUrl +
                          (this.state.donation.campaignDetail &&
                          this.state.donation.campaignDetail
                            .showAdditionalInstructions &&
                          this.state.donation.amount >= 1000
                            ? consts.PANEL_CAMPAIGN_INSTRUCTIONS
                            : this.state.donation.campaignDetail &&
                              this.state.donation.campaignDetail.thankYouMarkup
                            ? consts.PANEL_CAMPAIGN_THANK_YOU
                            : consts.PANEL_THANK_YOU)
                      );
                    }
                  );
                } else {
                  if (this.state.optIn) {
                    this.setState({
                      validation: {
                        ...this.state.validation,
                        name: validName,
                        notifyEmail: validEmail,
                      },
                    });
                  }
                }
              }}
            />
          )}
        />
        <Route
          path={this.state.originUrl + consts.PANEL_THANK_YOU}
          render={(props) => (
            <ThankYou
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              validation={this.state.account.settings.validation}
              images={this.state.account.settings.images}
              donation={this.state.donation}
              thankYouName={this.state.thankYouName}
              thankYouNote={this.state.thankYouNote}
              thankYouNameValid={this.state.validation.thankYouName}
              thankYouNoteValid={this.state.validation.thankYouNote}
              code={this.state.code}
              onCodeError={() => {
                this.reset(props);
                //this.openCodeError(props);
              }}
              onThankYouNameChanged={(thankYouName) => {
                let validThankYouName =
                  utilities.validateThankYouName(thankYouName);
                this.setState({
                  thankYouName: thankYouName,
                  validation: {
                    ...this.state.validation,
                    thankYouName: this.state.validation.thankYouName
                      ? this.state.validation.thankYouName
                      : validThankYouName,
                  },
                });
              }}
              onThankYouNoteChanged={(thankYouNote) => {
                let validThankYouNote =
                  utilities.validateThankYouNote(thankYouNote);
                this.setState({
                  thankYouNote: thankYouNote,
                  validation: {
                    ...this.state.validation,
                    thankYouNote: this.state.validation.thankYouNote
                      ? this.state.validation.thankYouNote
                      : validThankYouNote,
                  },
                });
              }}
              onContinue={() => {
                // this.state.selectedCharities.map((charity) => {
                //   if (charity.ein) {
                //     ReactGA.event({
                //       category: "Spend",
                //       action: charity.ein,
                //       label: "Donation to " + charity.name,
                //       value: charity.amount,
                //     });
                //   }
                // });
                // ReactGA.event({
                //   category: "User Action",
                //   action: "Spend Card",
                //   label: this.state.code,
                //   value: this.state.donation.amount,
                // });
                // ReactGA.event({
                //   category: "User Action",
                //   action: "Send Thank You",
                //   label: this.state.thankYouNote,
                // });
                let validThankYouName = utilities.validateThankYouName(
                  this.state.thankYouName
                );
                let validThankYouNote = utilities.validateThankYouNote(
                  this.state.thankYouNote
                );
                if (validThankYouName && validThankYouNote) {
                  this.setState({ busy: true }, () => {
                    utilities
                      .setDonation(
                        this.state.code,
                        this.state.name,
                        this.state.email,
                        this.state.optIn,
                        this.state.notifyEmail,
                        this.state.selectedCharities,
                        this.state.thankYouName,
                        this.state.thankYouNote,
                        this.state.donation.campaignDetail &&
                          this.state.donation.campaignDetail
                            .showAdditionalInstructions &&
                          this.state.donation.amount >= 1000
                          ? this.state.instructions
                          : null
                      )
                      .then(() => {
                        this.setState(
                          {
                            busy: false,
                          },
                          () => {
                            this.resetScroll();
                            props.history.push(
                              this.state.originUrl + consts.PANEL_SHARE_SPEND
                            );
                          }
                        );
                      })
                      .catch((err) => {
                        if (process.env.NODE_ENV === "development") {
                          console.log(err);
                        }
                        this.setState({
                          busy: false,
                          validation: {
                            ...this.state.validation,
                            code: false,
                          },
                        });
                      });
                  });
                } else {
                  this.setState({
                    validation: {
                      ...this.state.validation,
                      thankYouName: validThankYouName,
                      thankYouNote: validThankYouNote,
                    },
                  });
                }
              }}
              onBack={() => {
                this.goBack(props);
              }}
              onSkip={() => {
                // this.state.selectedCharities.map((charity) => {
                //   ReactGA.event({
                //     category: "Spend",
                //     action: charity.ein,
                //     label: "Donation to " + charity.name,
                //     value: charity.amount,
                //   });
                // });
                // ReactGA.event({
                //   category: "User Action",
                //   action: "Spend Card",
                //   label: this.state.code,
                //   value: this.state.donation.amount,
                // });
                // ReactGA.event({
                //   category: "User Action",
                //   action: "Skip Thank You",
                //   label: this.state.thankYouNote,
                // });
                this.setState({ busy: true }, () => {
                  utilities
                    .setDonation(
                      this.state.code,
                      this.state.name,
                      this.state.email,
                      this.state.optIn,
                      this.state.notifyEmail,
                      this.state.selectedCharities,
                      "",
                      "",
                      this.state.donation.campaignDetail &&
                        this.state.donation.campaignDetail
                          .showAdditionalInstructions &&
                        this.state.donation.amount >= 1000
                        ? this.state.instructions
                        : null
                    )
                    .then(() => {
                      this.setState(
                        {
                          busy: false,
                        },
                        () => {
                          this.resetScroll();
                          props.history.push(
                            this.state.originUrl + consts.PANEL_SHARE_SPEND
                          );
                        }
                      );
                    })
                    .catch((err) => {
                      if (process.env.NODE_ENV === "development") {
                        console.log(err);
                      }
                      this.setState({
                        busy: false,
                        validation: {
                          ...this.state.validation,
                          code: false,
                        },
                      });
                    });
                });
              }}
            />
          )}
        />
        <Route
          path={this.state.originUrl + consts.PANEL_SHARE_SPEND}
          render={(props) => (
            <ShareSpend
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              links={this.state.account.settings.links}
              images={this.state.account.settings.images}
              selectedCharities={this.state.selectedCharities}
              email={this.state.email}
              name={this.state.name}
              donation={this.state.donation}
              code={this.state.code}
              onEmptyCode={() => {
                props.history.push(this.state.originUrl);
              }}
            />
          )}
        />
        <Route
          path={this.state.originUrl + consts.PANEL_CODE_ERROR}
          render={(props) => (
            <CodeError
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              links={this.state.account.settings.links}
              images={this.state.account.settings.images}
              donation={this.state.donation}
              selectedCharities={this.state.selectedCharities}
              dateSpent={this.state.dateSpent}
              code={this.state.code}
              onEmptyCode={() => {
                props.history.push(this.state.originUrl);
              }}
            />
          )}
        />
        <Route
          render={(props) => (
            <CardCodeInput
              busy={this.state.busy}
              dictionary={this.state.account.settings.dictionary}
              validation={this.state.account.settings.validation}
              images={this.state.account.settings.images}
              code={this.state.code}
              email={this.state.email}
              codeValid={this.state.validation.code}
              emailValid={this.state.validation.email}
              onCodeChanged={(code) => {
                let validCode = utilities.validateCode(code);
                this.setState({
                  code: code,
                  validation: {
                    ...this.state.validation,
                    code: this.state.validation.code
                      ? this.state.validation.code
                      : validCode,
                  },
                });
              }}
              onEmailChanged={(email) => {
                let validEmail = utilities.validateEmail(this.state.email);
                this.setState({
                  email: email,
                  validation: {
                    ...this.state.validation,
                    email: this.state.validation.email
                      ? this.state.validation.email
                      : validEmail,
                  },
                });
              }}
              onSubmit={() => {
                let validCode = utilities.validateCode(this.state.code);
                let validEmail = utilities.validateEmail(this.state.email);
                if (validCode && validEmail) {
                  this.setState({ busy: true }, () => {
                    utilities
                      .getCodeDetail(this.state.code)
                      .then((donationResponse) => {
                        utilities
                          .getCategories(this.state.code)
                          .then((categories) => {
                            let additionalCharityCount =
                              this.state.account.settings
                                .additionalCharityCount <
                              donationResponse.amount / 3
                                ? this.state.account.settings
                                    .additionalCharityCount
                                : Math.floor(donationResponse.amount / 3) - 1;
                            additionalCharityCount =
                              additionalCharityCount > 0
                                ? additionalCharityCount
                                : 0;
                            this.setState(
                              {
                                busy: false,
                                donation: donationResponse,
                                notifyEmail: this.state.email,
                                categories: categories,
                                selectedCharities: [],
                                account: {
                                  ...this.state.account,
                                  settings: {
                                    ...this.state.account.settings,
                                    additionalCharityCount:
                                      additionalCharityCount,
                                  },
                                },
                              },
                              () => {
                                this.resetScroll();
                                props.history.push(
                                  this.state.originUrl +
                                    (donationResponse.campaignDetail &&
                                    donationResponse.campaignDetail
                                      .welcomeMarkup
                                      ? consts.PANEL_CAMPAIGN_WELCOME
                                      : consts.PANEL_CATEGORY_SELECTOR)
                                );
                              }
                            );
                          });
                      })
                      .catch((err) => {
                        if (process.env.NODE_ENV === "development") {
                          console.log(err);
                        }
                        try {
                          let errorResponse = JSON.parse(err.response);
                          if (errorResponse.code == "2.3") {
                            utilities
                              .getSpendDetail(this.state.code)
                              .then((spendDetail) => {
                                // ReactGA.event({
                                //   category: "Validation",
                                //   action: "Validate Card Code",
                                //   label: this.state.code + " has been spent",
                                // });
                                let dateSpent = new Date(spendDetail.dateSpent);
                                dateSpent =
                                  parseInt(dateSpent.getMonth() + 1) +
                                  "/" +
                                  dateSpent.getDate() +
                                  "/" +
                                  dateSpent.getFullYear();
                                this.setState(
                                  {
                                    busy: false,
                                    selectedCharities:
                                      spendDetail.charitySpentDetail,
                                    dateSpent: dateSpent,
                                  },
                                  () => {
                                    this.resetScroll();
                                    props.history.push(
                                      this.state.originUrl +
                                        consts.PANEL_CODE_ERROR
                                    );
                                  }
                                );
                              })
                              .catch(() => {
                                // ReactGA.event({
                                //   category: "Validation",
                                //   action: "Validate Card Code",
                                //   label: this.state.code + " is invalid",
                                // });
                                this.setState({
                                  busy: false,
                                  validation: {
                                    ...this.state.validation,
                                    code: false,
                                  },
                                });
                              });
                          } else {
                            // ReactGA.event({
                            //   category: "Validation",
                            //   action: "Validate Card Code",
                            //   label: this.state.code + " is invalid",
                            // });
                            this.setState({
                              busy: false,
                              validation: {
                                ...this.state.validation,
                                code: false,
                              },
                            });
                          }
                        } catch (e) {
                          // ReactGA.event({
                          //   category: "Validation",
                          //   action: "Validate Card Code",
                          //   label: this.state.code + " is invalid",
                          // });
                          this.setState({
                            busy: false,
                            validation: {
                              ...this.state.validation,
                              code: false,
                            },
                          });
                        }
                      });
                  });
                } else {
                  // if (validCode) {
                  //   ReactGA.event({
                  //     category: "Validation",
                  //     action: "Validate Card Code",
                  //     label: this.state.code + " is invalid",
                  //   });
                  // }
                  // if (validEmail) {
                  //   ReactGA.event({
                  //     category: "Validation",
                  //     action: "Validate Email",
                  //     label: this.state.email + " is invalid",
                  //   });
                  // }
                  this.setState({
                    validation: {
                      ...this.state.validation,
                      code: validCode,
                      email: validEmail,
                    },
                  });
                }
              }}
            />
          )}
        />
      </Switch>
    );
  }
  render() {
    if (this.state.account) {
      return (
        <div className={styles.app} lang="en">
          <style
            dangerouslySetInnerHTML={{
              __html: this.state.account.settings.styles,
            }}
          />
          {this.state.account.settings.showHeader ? (
            <Header
              dictionary={this.state.account.settings.dictionary}
              links={this.state.account.settings.links}
              images={this.state.account.settings.images}
              donation={this.state.donation}
            />
          ) : null}
          <div className={styles.content}>{this.renderPanel()}</div>
          {this.state.account.settings.showFooter ? (
            <Footer
              dictionary={this.state.account.settings.dictionary}
              links={this.state.account.settings.links}
            />
          ) : null}
        </div>
      );
    } else {
      return null;
    }
  }
}
export default withRouter(App);
